import { render, staticRenderFns } from "./PortalFacturacionView.vue?vue&type=template&id=168fb38c&scoped=true&"
import script from "./PortalFacturacionView.vue?vue&type=script&lang=js&"
export * from "./PortalFacturacionView.vue?vue&type=script&lang=js&"
import style0 from "./PortalFacturacionView.vue?vue&type=style&index=0&id=168fb38c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168fb38c",
  null
  
)

export default component.exports